import React from 'react';
import { EmptyTableIllustration } from './EmptyTableIllustration';

export function DataTable({ columns, rows, emptyText, rowKey }) {
  if (!rows?.length) {
    return (
      <div className="admin-table-shell admin-table-shell--empty">
        <div className="admin-table-empty">
          <EmptyTableIllustration />
          <p className="admin-table-empty-title mb-0">{emptyText || 'No data to show'}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-table-shell">
      <div className="table-responsive">
        <table className="table table-sm align-middle mb-0 admin-data-table">
          <thead>
            <tr>
              {columns.map((c) => (
                <th key={c.key} scope="col" className={c.key === 'actions' ? 'text-end' : ''} style={c.width ? { width: c.width } : undefined}>
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={rowKey ? rowKey(row) : idx}>
                {columns.map((c) => (
                  <td key={c.key} className={c.key === 'actions' ? 'text-end' : ''}>
                    {c.render ? c.render(row) : row[c.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
